import UserIcon from "@redotech/redo-icons/user-01.svg";
import { OMSUser } from "@redotech/redo-model/fulfillments/oms-user";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const OMSUserFilter = (
  users: OMSUser[],
): ArrayStringTableFilter<OMSUser> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  data: {
    name: "assignees",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  itemLabel: "user",
  Icon: UserIcon,
  values: users,
  stringify: (item: OMSUser | string) => {
    return typeof item === "string" ? item : item._id;
  },
  display: (item: OMSUser | string) => {
    if (typeof item === "string") {
      return users.find((user) => user._id === item)?.name || item;
    } else return item.name;
  },
  displayName: "Assignee",
});
